import { getEventInfoProdAccordion } from "@/components/ProductDetail/v3/ProductAccordionList/analytics"

export const handleSpecsDownload = (e, title, link, productInfo = null) => {
  e.stopPropagation()
  let errMsg
  const url = link.trim()
  try {
    window.open(url, "_blank")
  } catch (err) {
    errMsg = err.message
  }
  const eventInfo = getEventInfoProdAccordion(title, "specs", true, url, errMsg)
  const dataLayerProductInfo = productInfo
    ? JSON.parse(productInfo)?.productInfo
    : null
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    productInfo: dataLayerProductInfo,
  })
}
